import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimezoneConvertDatePipe } from './timezone-convert-date.pipe';
import { SafePipe } from './safe-pipe.pipe';
import { FilterPipe } from './filter.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    TimezoneConvertDatePipe,
    SafePipe,
    FilterPipe,
  ],
  exports: [
    TimezoneConvertDatePipe,
    SafePipe,
    FilterPipe
  ],
})
export class SharedPipeModule {
}
